var map = {
	"./001-road.svg": "033e",
	"./002-size.svg": "4710",
	"./003-thermometer.svg": "2953",
	"./004-sunset.svg": "b110",
	"./005-orbit-1.svg": "dfe8",
	"./006-orbit.svg": "1111",
	"./007-orbit-2.svg": "2f3e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";